/* Topscent Collection Cards: inject scent metadata below product images */
(function() {
  'use strict';

  var SCENT_DATA = {
    'apex': { character: 'Bold, Smokey, Magnetic', inspired: 'Inspired by Creed Aventus' },
    'noir': { character: 'Dark, Rich, Sophisticated', inspired: 'Inspired by Parfums de Marly Layton' },
    'ember': { character: 'Warm, Sweet, Addictive', inspired: 'Inspired by Baccarat Rouge 540' },
    'atlas': { character: 'Fresh, Clean, Confident', inspired: 'Inspired by Dior Sauvage' }
  };

  function init() {
    var cards = document.querySelectorAll('.product-card-wrapper, .card-wrapper');
    cards.forEach(function(card) {
      // Skip if already injected
      if (card.querySelector('.topscent-card-meta')) return;

      // Find the product link to determine the handle
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^?#/]+)/);
      if (!match) return;
      var handle = match[1].toLowerCase();

      var data = SCENT_DATA[handle];
      if (!data) return;

      // Build metadata HTML
      var meta = document.createElement('div');
      meta.className = 'topscent-card-meta';
      meta.innerHTML =
        '<p class="topscent-card-meta__name">' + handle.toUpperCase() + '</p>' +
        '<p class="topscent-card-meta__character">' + data.character + '</p>' +
        '<p class="topscent-card-meta__inspired">' + data.inspired + '</p>' +
        '<div class="topscent-card-meta__pills">' +
          '<span class="topscent-card-meta__pill">Up to 30 days</span>' +
          '<span class="topscent-card-meta__pill">Solid Cherry Wood</span>' +
        '</div>';

      // Insert AFTER the card wrapper (below the image, never overlapping)
      card.style.display = 'flex';
      card.style.flexDirection = 'column';
      card.appendChild(meta);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
